import React from 'react';
import "./FAQPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import {faq_s} from "../../data";
import Accordion from "../../Common/Accordion"



function App() {
  return <X11FAQsPageTablet {...x11FAQsPageTabletData} />;
}

export default App;

function X11FAQsPageTablet(props) {
  const {
    faqs,
    rectangle76,
    text127,
    text128,
    //frame144Props,
    //footer5Props,
    closeProps,
    frame15903Props,
    frame159032Props,
    frame159033Props,
    frame159034Props,
    frame159035Props,
    frame159036Props,
  } = props;

  return (
    <div className="faqpt-container-center-horizontal">
      <div className="faqpt-x11-faq-s-page-tablet screen">
        <div className="faqpt-overlap-group">
          <div className="faqpt-frame-1603">
            {/* <Frame144 group86Props={frame144Props.group86Props} iconMenuProps={frame144Props.iconMenuProps} /> */}
            <NavBar/>
            <h1 className="faqpt-fa-qs faqpt-valign-text-middle faqpt-typographyheadlineh4-extrabold-24">{faqs}</h1>
            {/* <img className="faqpt-rectangle-76" src={rectangle76} /> */}
            <img className="faqpt-rectangle-76" src={faq_s.FAQsHeader} alt="Webuildd FAQs" />
            

            {/* <Footer52 {...footer5Props} /> */}
            
          </div>
          <div className="faqpt-frame-1653">
            {/* <div className="faqpt-frame-1589 faqpt-border-1px-black-2">
              <div className="faqpt-frame-1591">
                <div className="faqpt-text-3 faqpt-valign-text-middle faqpt-typographyheadlineh4-extrabold-24">{text127}</div>
                <Close src={closeProps.src} />
              </div>
              <p className="faqpt-text-4 faqpt-typographybody16-regular">{text128}</p>
            </div>
            <Frame159032 text129={frame15903Props.text129} plusProps={frame15903Props.plusProps} />
            <Frame159032 text129={frame159032Props.text129} plusProps={frame159032Props.plusProps} />
            <Frame159032 text129={frame159033Props.text129} plusProps={frame159033Props.plusProps} />
            <Frame159032 text129={frame159034Props.text129} plusProps={frame159034Props.plusProps} />
            <Frame159032 text129={frame159035Props.text129} plusProps={frame159035Props.plusProps} />
            <Frame159032 text129={frame159036Props.text129} plusProps={frame159036Props.plusProps} /> */}
           <Accordion/>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}


function Frame144(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="faqpt-frame-144">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="faqpt-group-86">
      <White src={whiteProps.src} />
      <img className="faqpt-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="faqpt-white">
      <img className="faqpt-vector" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="faqpt-icon-menu">
      <img
        className="faqpt-vector-2"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="faqpt-vector-1" src={vector2} />
      <img className="faqpt-vector-1" src={vector3} />
    </div>
  );
}


// function Footer52(props) {
//   const {
//     group85,
//     place,
//     overlapGroup,
//     vector2,
//     phone,
//     overlapGroup1,
//     vector3,
//     text15,
//     text14,
//     contactWebuildCom,
//     quickLinks,
//     aboutUs,
//     projects,
//     gallery,
//     knowledgeTransfer,
//     blogs,
//     faqs,
//     group872Props,
//   } = props;

//   return (
//     <div className="faqpt-footer">
//       <div className="faqpt-flex-row-1">
//         <img
//           className="faqpt-vector-3"
//           src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
//         />
//         <img className="faqpt-group-85-1" src={group85} />
//         <Group872
//           facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
//           facebookAppSymbolProps2={group872Props.facebookAppSymbolProps2}
//           twitterProps={group872Props.twitterProps}
//         />
//       </div>
//       <div className="faqpt-flex-row-2">
//         <div className="faqpt-group-32">
//           <div className="faqpt-place faqpt-valign-text-middle faqpt-typographyheadlineh5-extrabold-20">{place}</div>
//           <div className="faqpt-flex-row-3">
//             <div className="faqpt-flex-col">
//               <div className="faqpt-map-pin-1">
//                 <div className="faqpt-overlap-group1" style={{ backgroundImage: `url(${overlapGroup})` }}>
//                   <img className="faqpt-vector-4" src={vector2} />
//                 </div>
//               </div>
//               <div className="faqpt-phone" style={{ backgroundImage: `url(${phone})` }}></div>
//               <div className="faqpt-mail">
//                 <div className="faqpt-overlap-group2" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//                   <img className="faqpt-vector-5" src={vector3} />
//                 </div>
//               </div>
//             </div>
//             <div className="faqpt-flex-col-1">
//               <p className="faqpt-text-2 faqpt-typography-body-smalltext-14-regular">{text15}</p>
//               <div className="faqpt-flex-col-item faqpt-valign-text-middle faqpt-typography-body-smalltext-14-regular">{text14}</div>
//               <div className="faqpt-flex-col-item faqpt-valign-text-middle faqpt-typography-body-smalltext-14-regular">
//                 {contactWebuildCom}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="faqpt-group-147">
//           <div className="faqpt-quick-links faqpt-valign-text-middle faqpt-typographyheadlineh5-extrabold-20">{quickLinks}</div>
//           <div className="faqpt-flex-row-4">
//             <div className="faqpt-about-us faqpt-valign-text-middle faqpt-typographybody16-regular">{aboutUs}</div>
//             <div className="faqpt-projects faqpt-valign-text-middle faqpt-typographybody16-regular">{projects}</div>
//           </div>
//           <div className="faqpt-flex-row">
//             <div className="faqpt-gallery faqpt-valign-text-middle faqpt-typographybody16-regular">{gallery}</div>
//             <div className="faqpt-knowledge-transfer faqpt-valign-text-middle faqpt-typographybody16-regular">{knowledgeTransfer}</div>
//           </div>
//           <div className="faqpt-flex-row">
//             <div className="faqpt-blogs faqpt-valign-text-middle faqpt-typographybody16-regular">{blogs}</div>
//             <div className="faqpt-fa-qs-1 faqpt-valign-text-middle faqpt-typographybody16-regular">{faqs}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


function Group872(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div className="faqpt-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram2 overlapGroup1={facebookAppSymbolProps2.overlapGroup1} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="faqpt-facebook-app-symbol">
      <img className="faqpt-f-1" src={src} />
    </div>
  );
}


function Instagram2(props) {
  const { overlapGroup1, vector2 } = props;

  return (
    <div className="faqpt-instagram">
      <div className="faqpt-overlap-group1-1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
        <img
          className="faqpt-vector-6"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-155@2x.svg"
        />
        <img className="faqpt-vector-7" src={vector2} />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="faqpt-twitter">
      <img className="faqpt-vector-8" src={src} />
    </div>
  );
}


function Close(props) {
  const { src } = props;

  return (
    <div className="faqpt-close">
      <img className="faqpt-vector-9" src={src} />
    </div>
  );
}


function Frame159032(props) {
  const { text129, plusProps } = props;

  return (
    <div className="faqpt-frame-159 faqpt-border-1px-black-2">
      <div className="faqpt-text faqpt-valign-text-middle faqpt-typographyheadlineh4-extrabold-24">{text129}</div>
      <Plus src={plusProps.src} />
    </div>
  );
}


function Plus(props) {
  const { src } = props;

  return (
    <div className="faqpt-plus">
      <img className="faqpt-vector-10" src={src} />
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-3@2x.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame144Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const instagram2Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-154@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-19@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-157@2x.svg",
};

const group872Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagram2Data,
    twitterProps: twitterData,
};

// const footer52Data = {
//     group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-21@2x.svg",
//     place: "Contact",
//     overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-21@2x.svg",
//     phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-151@2x.svg",
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-152@2x.svg",
//     vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-153@2x.svg",
//     text15: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
//     text14: "+91 8976535221, +91 8755645342",
//     contactWebuildCom: "contact@webuild.com",
//     quickLinks: "Quick Links",
//     aboutUs: "About Us",
//     projects: "Projects",
//     gallery: "Gallery",
//     knowledgeTransfer: "Knowledge Transfer",
//     blogs: "Blogs",
//     faqs: "FAQ’s",
//     group872Props: group872Data,
// };

const closeData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-118@2x.svg",
};

const plusData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
};

const frame159032Data = {
    text129: "Lorem Ipsum passages ?",
    plusProps: plusData,
};

const plus2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
};

const frame1590322Data = {
    text129: "Lorem Ipsum passages ?",
    plusProps: plus2Data,
};

const plus3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
};

const frame1590323Data = {
    text129: "Lorem Ipsum passages ?",
    plusProps: plus3Data,
};

const plus4Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
};

const frame1590324Data = {
    text129: "Lorem Ipsum passages ?",
    plusProps: plus4Data,
};

const plus5Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
};

const frame1590325Data = {
    text129: "Lorem Ipsum passages ?",
    plusProps: plus5Data,
};

const plus6Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
};

const frame1590326Data = {
    text129: "Lorem Ipsum passages ?",
    plusProps: plus6Data,
};

const x11FAQsPageTabletData = {
    faqs: "FAQ’s",
    rectangle76: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76-6@1x.png",
    text127: "Lorem Ipsum passages ?",
    text128: "There are many variations of passages of Lorem Ipsum available but the majority have suffered dummy alteration in that an some form by the injected humour or randomised words which don’t look even that slightly believable. If you are Lorem Ipsums your need to be sure there isn’t anything embarrassing.",
    frame144Props: frame144Data,
    //footer5Props: footer52Data,
    closeProps: closeData,
    frame15903Props: frame159032Data,
    frame159032Props: frame1590322Data,
    frame159033Props: frame1590323Data,
    frame159034Props: frame1590324Data,
    frame159035Props: frame1590325Data,
    frame159036Props: frame1590326Data,
};

